import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class LoggerService {
  constructor(private http: HttpClient) {}

  updateLog(data: any) {
    return this.http.post(`/api/Logger/updateLog`, data, {
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/audit-logger.service.ts